import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=34534a5f&scoped=true&"
import script from "./VideoControl.vue?vue&type=script&lang=js&"
export * from "./VideoControl.vue?vue&type=script&lang=js&"
import style0 from "./VideoControl.vue?vue&type=style&index=0&id=34534a5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34534a5f",
  null
  
)

export default component.exports